import { deleteSubscriptionContract } from "../mutations/deleteSubscriptionContract.subscriptions.js";
import { getSubscriptionContractDetails, } from "./getSubscriptionContractDetails.js";
import { updateSubscriptionContract } from "../mutations/updateSubscriptionContract.subscriptions.js";
import { PAYMENT_PROPERTY } from "../../payment/index.js";
import { resolveRenewAtContext } from "../utils/resolveNextRenewAt.js";
import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
import { isSubscriptionShapeBookClub } from "../../subscription-plan/selectors/isSubscriptionShape.js";
export const resolvePendingContract = async ({ contractId, approved }, { client }) => {
    if (!approved) {
        await deleteSubscriptionContract({ id: contractId }, { client });
        return {
            success: true,
        };
    }
    const contract = await getSubscriptionContractDetails({ contractId }, { client });
    const updatedPayment = removePendingPropertiesFromPayment({ contract });
    const isBookClub = isSubscriptionShapeBookClub(contract.type);
    const { renewAt: initialRenewDate, bookSubscriptionRenewContext } = resolveRenewAtContext(contract.type, contract.nextBook, contract.giftConfig.count > 0, contract.dispatches);
    const updatedStatus = {
        renewAt: initialRenewDate,
        activeUntil: initialRenewDate,
    };
    const updatedContract = {
        status: updatedStatus,
        payment: updatedPayment,
    };
    const metaWithoutDispatchBatchCode = (contract.meta ?? []).filter(({ key }) => key !== SUBSCRIPTION_CONTRACT_META_KEY.DISPATCH_BATCH_CODE);
    const dispatchBatchCodeMeta = isBookClub &&
        !bookSubscriptionRenewContext?.isGiftRenewal &&
        bookSubscriptionRenewContext?.selectedDispatch?.batchCode
        ? [
            {
                key: SUBSCRIPTION_CONTRACT_META_KEY.DISPATCH_BATCH_CODE,
                value: bookSubscriptionRenewContext.selectedDispatch.batchCode,
            },
        ]
        : [];
    await updateSubscriptionContract({
        ...updatedContract,
        id: contractId,
        meta: [
            ...metaWithoutDispatchBatchCode,
            ...dispatchBatchCodeMeta,
            {
                key: SUBSCRIPTION_CONTRACT_META_KEY.PENDING_CONTRACT_APPROVED_AT,
                value: new Date().toISOString(),
            },
        ],
    }, { client });
    return {
        success: true,
    };
};
const removePendingPropertiesFromPayment = ({ contract: details, }) => {
    const payment = details.payment;
    return {
        ...payment,
        custom: {
            ...payment.custom,
            properties: payment.custom?.properties?.filter(({ property }) => property !== PAYMENT_PROPERTY.CONTRACT.CONTRACT_PENDING_STATUS &&
                property !== PAYMENT_PROPERTY.CONTRACT.PENDING_SNAPSHOT &&
                property !== PAYMENT_PROPERTY.CONTRACT.PENDING_NON_MATCHING_FIELDS),
        },
    };
};
